import apiClient from './config';

export default {
  // Récupérer les statistiques du dashboard
  getDashboardStats() {
    return apiClient.get('/firm/analytics/dashboard');
  },

  // Récupérer les données de la semaine du calendrier
  getCalendarWeekData(params = {}) {
    return apiClient.get('/firm/analytics/calendar-week', { params });
  },

  // Récupérer l'historique du taux de réponse
  getResponseRateHistory(params = {}) {
    return apiClient.get('/firm/analytics/response-rate', { params });
  },

  // Récupérer les KPIs globaux
  getGlobalKPIs() {
    return apiClient.get('/firm/analytics/kpis');
  },

  // Récupérer les statistiques de revenus
  getRevenueStats(params = {}) {
    return apiClient.get('/firm/analytics/revenue', { params });
  },

  // Récupérer les statistiques des clients
  getClientStats() {
    return apiClient.get('/firm/analytics/clients');
  },

  // Récupérer les statistiques du personnel
  getStaffStats() {
    return apiClient.get('/firm/analytics/staff');
  },

  // Récupérer les statistiques des rendez-vous
  getAppointmentStats(params = {}) {
    return apiClient.get('/firm/analytics/appointments', { params });
  },

  // Récupérer le flux de trésorerie (CA par période)
  getRevenueFlow(params = {}) {
    return apiClient.get('/firm/analytics/revenue-flow', { params });
  },

  // Récupérer la performance des services
  getServicesPerformance(params = {}) {
    return apiClient.get('/firm/analytics/services-performance', { params });
  },

  // Récupérer les alertes et points de friction
  getAlerts() {
    return apiClient.get('/firm/analytics/alerts');
  },
};
